import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import Analytics from '../components/Template/Analytics';
import Navigation from '../components/Template/Navigation';
import SideBar from '../components/Template/SideBar';
import ScrollToTop from '../components/Template/ScrollToTop';

const Main = (props) => (
  <HelmetProvider>
    <Analytics />
    <ScrollToTop />
    <Helmet
      titleTemplate="%s | Alex Sandro Colombo"
      defaultTitle="Alex Sandro Colombo"
      defer={false}
    >
      {props.title && <title>{props.title}</title>}
      <meta name="description" content={props.description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://alexsandrocolombo.com/" />
      <meta property="og:title" content={props.title || 'Alex Sandro Colombo'} />
      <meta property="og:description" content={props.description} />
      <meta property="og:image" content="https://alexsandrocolombo.com/images/og-image.jpg" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://alexsandrocolombo.com/" />
      <meta property="twitter:title" content={props.title || 'Alex Sandro Colombo'} />
      <meta property="twitter:description" content={props.description} />
      <meta property="twitter:image" content="https://alexsandrocolombo.com/images/og-image.jpg" />

      <link rel="canonical" href="https://alexsandrocolombo.com/" />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'Person',
          name: 'Alex Sandro Colombo',
          url: 'https://alexsandrocolombo.com',
          sameAs: [
            'https://github.com/AleSkywaker',
            'https://www.linkedin.com/in/alexsandrocolombo',
            'https://twitter.com/AleSkywaker',
          ],
          jobTitle: 'VP of Engineering',
          worksFor: {
            '@type': 'Organization',
            name: 'Telefonica, S.A.',
          },
          description: 'Valencia based, Senior Full Stack developer, founder of CodeInmersion.io, tech enthusiast and open source contributor.',
        })}
      </script>
    </Helmet>
    <div id="wrapper">
      <Navigation />
      <div id="main">{props.children}</div>
      {props.fullPage ? null : <SideBar />}
    </div>
  </HelmetProvider>
);

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullPage: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
};

Main.defaultProps = {
  children: null,
  fullPage: false,
  title: null,
  description: "Alex Sandro Colombo's personal website.",
};

export default Main;
